import { ReactNode } from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { useStudentContext } from "../../../../../context/studentContext";
import { LoadingButton } from "@mui/lab";
import EmailForm, { EmailFormSchema } from "../../SendToParentOptions/EmailForm";
import SendIcon from "@mui/icons-material/Send"
import { EDIT_STUDENT_PARENT_EMAIL } from "../../../../../features/graphql/mutation/students/editStudentParentEmailMutation";
import { EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables, Student } from "../../../../../__generated__/graphql";
import { useMutation } from "@apollo/client";
import { useManageModal } from "../../../../Manage/components/ManageModal";
import { useSlideInContext } from "../../../../../context/SlideInContext";
export type REQ_EMAIL_OPTIONS = "parent" | "student";

export type SelectEmailProps = {
    onSelect: (email: REQ_EMAIL_OPTIONS) => {};
    loadStatus: boolean
}

function LaunchButton({
    email: type, loadStatus, onAction, children }: {
        email: REQ_EMAIL_OPTIONS,
        loadStatus: boolean,
        onAction: (email: REQ_EMAIL_OPTIONS) => {}, children: ReactNode
    }) {
    return (
        <LoadingButton
            sx={{
                backgroundColor: "primary.main",
                "&:hover": {
                    backgroundColor: "primary.light",
                },
                width: 300,
                marginTop: "16px",
                padding: 1
            }}
            type="submit"
            variant="contained"
            loading={loadStatus}
            loadingPosition="end"
            disabled={loadStatus}
            endIcon={<SendIcon />}
            onClick={() => onAction(type)}>{children}</LoadingButton>
    )
}
export default function SendToWhichEmail({ onSelect, loadStatus }: SelectEmailProps) {
    const { studentData, updateStudent } = useStudentContext()
    const [editStudentParentEmail, { data }] = useMutation<EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables>(EDIT_STUDENT_PARENT_EMAIL);
    const { openModal } = useManageModal()
    const { toggleDrawer } = useSlideInContext()
    const handleEmailSubmission = async (values: EmailFormSchema) => {
        openModal({ type: "EDIT_IN_PROGRESS" })
        const response = await editStudentParentEmail({
            variables: {
                id: studentData.id,
                parentEmail: values.email
            }
        });
        updateStudent({
            parentEmail: values.email
        } as Student);
        if (!response.errors) {
            openModal({ type: "SAVED_CHANGES", cancelButtonLabel: "Close" })
        } else {
            openModal({ type: "GENERAL_ERROR" })
        }
        if (response.data) {
            console.log("response: ", response)
            toggleDrawer()
        }
        // console.error(response.errors?.at(0)?.message);
    }


    if (studentData.email && studentData.parentEmail) {
        return (
            <>
                <Grid size={12}>
                    <LaunchButton
                        email="student"
                        loadStatus={loadStatus}
                        onAction={() => onSelect("student")}
                    >Send to Child Email: {studentData.email}</LaunchButton>
                </Grid>
                <Grid size={12}>
                    <LaunchButton
                        email="parent"
                        loadStatus={loadStatus}
                        onAction={() => onSelect("parent")}
                    >Send to Parent Email: {studentData.parentEmail}</LaunchButton>
                </Grid>
            </>
        )
    }
    if (studentData.email && !studentData.parentEmail) {
        return (
            <>
                <Grid size={12}>
                    <LaunchButton
                        email="student"
                        loadStatus={loadStatus}
                        onAction={() => onSelect("student")}
                    >Send to Child Email: {studentData.email}</LaunchButton>
                </Grid>
            </>
        )
    }
    if (!studentData.email && studentData.parentEmail) {
        return (
            <>
                <Grid size={12}>
                    <LaunchButton
                        email="parent"
                        loadStatus={loadStatus}
                        onAction={() => onSelect("parent")}
                    >Send to Parent Email: {studentData.parentEmail}</LaunchButton>
                </Grid>
            </>
        )
    }
    return (<Box>
        <Grid size={12}>
            <Box id='test' sx={{ alignItems: "center" }}>
                <Typography>There's no parent email for this child, please provide an email, then you can launch remotely.</Typography>
                <EmailForm onSubmit={handleEmailSubmission} />
            </Box>
        </Grid>

    </Box>)
}